module.exports = __webpack_public_path__ + "b9084e864474deed1f253d8726740032.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/huangjin_c.png
// module id = 268
// module chunks = 3